export function formatDMY(value: any): string {
  const d = toDate(value);
  if (!d) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

/** Parse a variety of inputs -> Date (local, midnight). Supports ISO or d[-/]m[-/]yyyy */
export function toDate(value: any): Date | null {
  if (!value) return null;

  // Already a Date
  if (value instanceof Date && !isNaN(value.getTime())) return new Date(value.getFullYear(), value.getMonth(), value.getDate());

  // Numeric (Excel serial etc.)
  if (typeof value === 'number') {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  // ISO-like
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  // d-m-yyyy or d/m/yyyy (1 or 2 digit d/m)
  if (typeof value === 'string') {
    const m = value.trim().match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
    if (m) {
      const day = +m[1], mon = +m[2], yr = +m[3];
      const d = new Date(yr, mon - 1, day);
      // Validate (e.g., 31-02-2024 should be rejected)
      if (d.getFullYear() === yr && d.getMonth() === mon - 1 && d.getDate() === day) {
        return d;
      }
    }
  }
  return null;
}

export function compareDates(a: any, b: any): number {
  const da = toDate(a)?.getTime() ?? -Infinity;
  const db = toDate(b)?.getTime() ?? -Infinity;
  return da === db ? 0 : da < db ? -1 : 1;
}

/** AG Grid Date filter comparator — compares cell value vs filter value (both local midnight) */
export const dateFilterComparator = (filterLocalDateAtMidnight: Date, cellValue: any) => {
  const cellDate = toDate(cellValue);
  if (!cellDate) return -1; // treat empty as "less"
  const a = cellDate.getTime();
  const b = new Date(
    filterLocalDateAtMidnight.getFullYear(),
    filterLocalDateAtMidnight.getMonth(),
    filterLocalDateAtMidnight.getDate()
  ).getTime();

  return a === b ? 0 : a < b ? -1 : 1;
};